import React  , { Component } from 'react';

import { HomeSlider, HomeTitle } from '../../Components/UI/UI';

import {getWeather} from '../../Utility/Utility';
import Menu from '../../Components/Menu/Menu';
import Footer from '../../Components/Footer/Footer';
import './InfoForPastors.css';



class FAQ extends Component {

  state = {
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }



  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
  render(){
   
    return(
      <div className="page align-center page-FAQ inner-page page-infoforpastors">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        <div class="container">
           <HomeTitle>
           INFO FOR PASTORS
            </HomeTitle>
            <div className="clear"></div>
            
            <div className="info-wrapper">
                <h3>PLANNING A TRIP</h3>
                   

                  <p>Pray for the peace of Jerusalem! “May they be secure who love you! Peace be within your walls and security within your towers!” Psalm 122:6-7 </p>

                   

                  <p>Every year Christians from around the world flock to Israel where their faith is fortified and their understanding of the Bible is enhanced. Their present and futures lives forever impacted. Something about sailing on the Sea of Galilee, walking the cobble-stoned streets of Jerusalem and viewing the empty tomb creates an everlasting change of heart and spirit. Wherever you go, you can sense God’s presence; each day a life-transforming experience.  </p>

                   

                  <p>The adventure begins here, in this special section of the website, prepared especially for Christian leaders like you. Every detail you need to organize and host your own trip to Israel is included. You will find answers to the questions most often asked about leading a group to the land of the Bible. Most of all you’ll discover how you can do your part to make sure your trip is one that leaves people forever inspired and eternally changed.</p>

                   

                  <p class="ac-margin-bot-20">I will bless those who bless you, and him who dishonors you I will curse, and in you all the families of the earth shall be blessed. Genesis 12:3 </p>

                   

                  <h3>Why should I plan a trip to Israel?</h3>

                   

                  <p>A trip to Israel is life-changing for you as a leader and for your congregation. Your teaching will be richer having seen the places where Jesus taught, ministered and died. Walking the path of the biblical stories and seeing the places where they happened gives you a fuller understanding of the connection between the Bible and the geography.</p>

                   

                  <p class="ac-margin-bot-20">For your fellow travelers and church members, a trip to Israel will foster a stronger connection to the church. When trip members return, they will have shared an incredible journey of faith together; and for church members who didn’t go, the opportunity they had to follow the trip gives them a strong sense of connectedness. The church can see an increased commitment of volunteer and service among members, a stronger sense of community and even an increase in tithing</p>

                   

                  <h3>Where do I begin?</h3>

                   

                  <p>The important part is making the decision to go. This needs to be firm.  It should be “I am going.” As the Pastor, you need to be the number one cheerleader for the trip. Your church will follow your lead, once you take this step of faith, the rest is easy.</p>

                   

                  <p class="ac-margin-bot-20">Now that you have made the decision to go you need to understand who you will invite. Your church is the place to start. Make an announcement at services that you will be going and ask church members to join you for this trip of a lifetime.  Once you have invited your congregation consider inviting other churches in your district and churches in your community. </p>

                   

                  <h3>Who can help me plan my trip?</h3>

                   

                  <p>The Israel Ministry of Tourism is here to help. At your request, your nearest Israel Ministry of Tourism office will send you a list of travel and tour organizers who specialize in faith-based trips to Israel or you can find a list here.</p>

                   

                  <p>As the Ministry of Tourism, we are a noncommercial government agency and do not sell trips to Israel. We are here to help you plan a successful and rewarding visit to the Holy Land.</p>

                   

                  <p class="ac-margin-bot-20">Once you have a list of travel partners you can reach out to them to begin planning your trip. Many of the operators have decades of experience in leading trips to Israel and are happy to assist you in planning.</p>

                   

                  <h3>What questions should I ask an Operator? </h3>

                   

                  <p>Can the tour be customized? Be sure to share with the operator places you would like to visit during your trip. You don’t have to plan the whole trip, but if there are sites you would like to visit let the Operator know so they can add them to the itinerary.</p>
                  <p class="ac-margin-bot-20">Will there be an opportunity for me to teach and lead worship on site? <br/>
                  Can I speak to the guide before the trip? <br/>
                  Can we add a service project to the itinerary? </p>
                   

                  <h3>When should I go?</h3>

                   

                  <p>Once you have selected an operator you are ready to start planning your trip.</p>

                   

                  <p>The first step in planning is picking the dates you would like to go.  Generally, it takes 12-18 months to plan your trip. This will give you ample time to promote the trip and have people sign on. </p>

                   

                  <p>The time of year is up to you.  Unless you would like to specifically be there during Christmas or Easter, you may want to schedule your trip at a time other than these busy holiday seasons. Many Christian groups prefer to travel when lower, off-season rates are available – usually November through mid-March (except Christmas) </p>

                   

                  <p>Your travel partner can help you select the best time for your group to travel.</p>

                   

                  <p class="ac-margin-bot-20">When deciding on your dates you will need to determine the length of your trip, a typical itinerary is 10 or more days giving you ample time to see Israel.</p>

                   

                  <h3>How affordable is a trip to Israel?</h3>

                   

                  <p>Your tour operator will work with you on the pricing of your trip and can assist you in creating an rewarding trip within your budget.</p>

                   

                  <p>Many of the tour operators will offer a pricing structure that will allow for one free passenger for a set number of passengers.</p>

                   

                  <p>Some items to discuss with your operator as you are discussing pricing include:</p>

                   

                  <p>Airfare – Domestic and International – Some leaders choose to include the price of airfare in their packages while others will decide to allow their passengers to book on their own. There are benefits to both cases.  The first is passengers will not have to worry about the stress and headache of booking their flights, but by not including the flights it allows passengers to use loyalty programs to book their trips.</p>

                   

                  <p>Meals – You can decide if you would like to include all meals in the price of your trip so that trip participants are not having to pay anything once they arrive in Israel or you can decide to include some meals and allow guests to purchase some meals on their own.</p>

                   

                  <p class="ac-margin-bot-20">Level of accommodations – Israel offers many levels of hotels throughout the country. We are known for our warm hospitality and level of service. We offer many options when it comes to accommodations.  Whether you stay at a hotel, a Kibbutz, a guest house or in a Bedouin tent, you can rest assure your guests will be comfortable and well taken care. </p>

                   

                  <h3>Who will be the lead point of contact from the ministry? </h3>

                   

                  <p>We realize as a leader sometimes it is impossible for you to oversee every detail as you continue to minister to your church and community. Your tour operator will be there to assist and make it as seamless as possible for you and your members. </p>

                   

                  <p class="ac-margin-bot-20">You will also need to have a person who is available to assist in fielding questions and providing information that members are familiar with at the church. You might decide you will be the point of contact or have an assistant or ministry leader who will take on this role for the church. </p>

                   

                  <h3>How do I promote my trip?</h3>

                   

                  <p>Now that you have selected your travel partner and set you dates, it is time to start promoting the trip. Please keep in mind key deadlines set by your travel partner so you can communicate them to potential travelers. You will need to include deadline to sign on, deposit dates and final payment dates.</p>

                   

                  <p>As you begin to market your trip, the biggest marketing tool you have is yourself. By announcing it on Sunday and inviting people to join you can start the buzz about the trip. Make sure after you have announced your trip you announce the trip in your church newsletter, on your website and your social media channels. Your tour operator can also assist you in creating a one-sheet about the trip that you can have available.</p>

                   

                  <p>A great way to get people excited is to offer an informational session about your trip.  You can do this in-person or through a virtual presentation.  Your tour operator and the local Israel Ministry of Tourism office can assist you at this session. During the presentation make sure to share pictures of the places you will visit and give people the opportunity to ask questions about the trip. Be prepared to have people sign up and give their deposits at this meeting.</p>

                  <p class="ac-margin-bot-20">Don’t try to guess everyone who will go.  You will be surprised by who decides to go. And make sure you encourage people who are registering to invite their family and friends to join them.</p>

                   

                  <h3>How should I prepare for the trip?</h3>

                   

                  <p>It is important to communicate regularly with participants. Be sure to share the itinerary and details of the trip with your fellow travelers.  This will allow them to prepare for their trip and get excited for the places they will visit.</p>

                   

                  <p>You may want to consider doing a weekly Bible study where you walk through the itinerary. This will help travelers to become more familiar and have knowledge of these incredible places where Jesus lived and taught.</p>

                   

                  <p class="ac-margin-bot-20">Based on the itinerary, plan places to stop and do a devotional or lead worship.</p>

                   

                  <h3>What should I do once I am in Israel?</h3>

                   

                  <p>Enjoy! </p>

                   

                  <p>This is the time you can lay the foundation for future trips. Be sure to regularly update your congregation at home about your trip. Post photos, videos, updates and stories through your social media channels and your website. Bring them along in your journey through the Holy Land.</p>

            </div>
            <div className="clear"></div>
        </div>
        <Footer />
      </div>
    )
  }

}



export default FAQ


// WEBPACK FOOTER //
// ./src/Pages/InfoForPastors/InfoForPastors.js